module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/CH_contents"
    }
  }, [_vm._v("About the authors")])]), _vm._v(" "), _c('p', {
    staticClass: "fo"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John Stott")]), _vm._v(" had a worldwide ministry as a church leader, a Bible expositor and the author of many award-winning books. He was Rector Emeritus of All Souls, Langham Place, London, and Founder-President of the Langham Partnership.")]), _vm._v(" "), _c('p', {
    staticClass: "fo_space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tim Chester")]), _vm._v(" is Pastor of Grace Church, Boroughbridge, North Yorkshire, Chair of Keswick Ministries and the author of more than forty books.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ea5f6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/CH_authors.vue
// module id = 72
// module chunks = 0